import { render, staticRenderFns } from "./setups.vue?vue&type=template&id=51ac6cf5&scoped=true&"
import script from "./setups.vue?vue&type=script&lang=js&"
export * from "./setups.vue?vue&type=script&lang=js&"
import style0 from "./setups.vue?vue&type=style&index=0&id=51ac6cf5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac6cf5",
  null
  
)

export default component.exports